import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { prpHttpAPI } from '../../services/prpHttpAPI';
import styleHeader from './Header.module.css';
import prpLogo from '../../assets/prp-new-logo.png';
import logo from '../../assets/logo.png'

const InputIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    <line x1="9" y1="12" x2="15" y2="12"></line>
    <line x1="9" y1="16" x2="15" y2="16"></line>
    <line x1="9" y1="8" x2="11" y2="8"></line>
  </svg>
);

const PdfIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <line x1="10" y1="9" x2="8" y2="9"></line>
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

const LogoutIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const [downloadFlag, setDownloadFlag] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isLatestVersion, setIsLatestVersion] = React.useState(true);

  React.useEffect(() => {
    setDownloadFlag(false);
  }, [path]);

  React.useEffect(() => {
    const checkVersionStatus = () => {
      const versionsRaw = localStorage.getItem('versions');
      const totalVers = Number(versionsRaw) || 1;
      const selectedVerRaw = localStorage.getItem('selectedVersion');
      const currentSelected = selectedVerRaw ? Number(selectedVerRaw) : totalVers;

      setIsLatestVersion(currentSelected >= totalVers);
    };

    checkVersionStatus();

    window.addEventListener('versionChanged', checkVersionStatus);
    window.addEventListener('storage', checkVersionStatus);

    return () => {
      window.removeEventListener('versionChanged', checkVersionStatus);
      window.removeEventListener('storage', checkVersionStatus);
    };
  }, [path]);

  const isSearchPage = path === '/search';
  const isAdminPage = path === '/admin';
  const isFlowPage = ['/client-details', '/client-investments', '/insurance-loans', '/goal-detail', '/plan-output'].includes(path);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/?action=logout');
  };

  const handleInputScreens = () => {
    const userData = localStorage.getItem('userData');
    const investmentData = localStorage.getItem('clientInvestmentData');

    if (!userData) {
      navigate('/client-details');
    } else if (!investmentData) {
      navigate('/client-investments');
    } else {
      navigate('/client-details');
    }
  };

  const handlePlanPdf = () => {
    navigate('/plan-output');
  };

  const previousPage = location.state?.from || "";
  const plan_id_val = JSON.parse(localStorage.getItem('userData') || '{}')?.plan_id;

  // Read plan completed status directly from localStorage
  const userDataRaw = localStorage.getItem('userData');
  let planCompleted = false;
  if (userDataRaw) {
    try {
      const userData = JSON.parse(userDataRaw);
      planCompleted = userData.plan_completed === true || userData.plan_completed === 1 || userData.clientsDetails?.plan_completed === true || userData.clientsDetails?.plan_completed === 1;
    } catch (e) {
      planCompleted = false;
    }
  } else {
    planCompleted = false;
  }

  const planCompletedFlagStr = localStorage.getItem('planCompletedFlag');
  let planCompletedFlag = false;
  if (planCompletedFlagStr) {
    try {
      planCompletedFlag = JSON.parse(planCompletedFlagStr) === true || planCompletedFlagStr === 'true';
    } catch (e) {
      planCompletedFlag = planCompletedFlagStr === 'true';
    }
  }

  const isNewPlan = isLatestVersion &&
    !planCompleted &&
    !planCompletedFlag &&
    !downloadFlag;

  const handleDownload = async () => {
    const userDataObj = JSON.parse(localStorage.getItem('userData') || '{}');
    const rawPlanId = userDataObj?.plan_id || '';
    const basePlanId = rawPlanId ? rawPlanId.split('_')[0] : '';
    const versionsRaw = localStorage.getItem('versions');
    const totalVers = Number(versionsRaw) || 1;
    const selectedVerRaw = localStorage.getItem('selectedVersion');
    const selectedVer = selectedVerRaw ? Number(selectedVerRaw) : totalVers;

    const versionedPlanId = selectedVer <= 1 ? basePlanId : `${basePlanId}_${selectedVer}`;
    if (!versionedPlanId) return;

    setIsDownloading(true);
    const data = {
      plan_id: versionedPlanId,
      send_notifications: true
    }
    try {
      const result = await prpHttpAPI(data, 'get-pdf/pdf', null, "POST", null);
      if (result.success && result.url) {
        const link = document.createElement("a");
        link.href = result.url;
        link.target = "_blank";
        link.download = `${versionedPlanId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        if (isNewPlan) {
          const localtoken = localStorage.getItem("ssotoken");
          const statusResult = await prpHttpAPI(data, 'status', localtoken, "POST", null);
          if (statusResult) {
            console.log("result in status api", statusResult);
          }
          setDownloadFlag(true);
          localStorage.setItem('planCompletedFlag', 'true');
          const userDataRaw = localStorage.getItem('userData');
          if (userDataRaw) {
            try {
              const userDataParsed = JSON.parse(userDataRaw);
              userDataParsed.plan_completed = true;
              if (userDataParsed.clientsDetails) {
                userDataParsed.clientsDetails.plan_completed = true;
              }
              localStorage.setItem('userData', JSON.stringify(userDataParsed));
            } catch (e) { }
          }
        }
      }
    } catch (error) {
      console.error("Download failed", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleEdit = () => {
    const planCompletedFlagString = localStorage.getItem('planCompletedFlag');
    const planCompletedFlag = planCompletedFlagString ? JSON.parse(planCompletedFlagString) : true;

    if (planCompletedFlag === false) {
      localStorage.setItem('userData', localStorage.getItem('editableData'));
    }
    localStorage.removeItem('planDetails');
    navigate('/client-details?path=edit');
  };

  const [rmData, setRmData] = React.useState(() => JSON.parse(localStorage.getItem('logged_rm_info') || '{}'));
  React.useEffect(() => {
    if (rmData?.EMP_NAME) return;
    const t = setInterval(() => { const d = JSON.parse(localStorage.getItem('logged_rm_info') || '{}'); if (d?.EMP_NAME) { setRmData(d); clearInterval(t); } }, 500);
    return () => clearInterval(t);
  }, []);
  const clientName = rmData?.EMP_NAME || '';
  const rmName = rmData?.EMP_PAYROLL_ID || rmData?.EMP_NAME || 'User';

  return (
    <header className={styleHeader.headerWrapper}>
      <div className={styleHeader.headerContent}>
        <div className={styleHeader.leftSection}>
          {/* <div className={styleHeader.toolBrand} onClick={() => navigate('/search')} style={{ cursor: 'pointer' }}>
  <img src={prpLogo} alt="Bajaj Capital" className={styleHeader.headerLogo} />
    <span className={styleHeader.toolTitle}>Pre-Retirement Tool</span>
  
</div> */}
          <div className={styleHeader.toolBrand} onClick={() => navigate('/search')} style={{ cursor: 'pointer' }}>
            <span className={styleHeader.toolTitle}>Pre-Retirement Tool</span>
          </div>
          <div className={styleHeader.divider}></div>
          <div className={styleHeader.teamName}>
            {/* <span className={styleHeader.incubatedText}>incubated by</span>
  <span className={styleHeader.incubatedText}>Bajaj Capital</span> */}
          </div>
        </div>

        <div className={styleHeader.rightSection}>

          {isSearchPage && (
            <button className={styleHeader.linkBtn} onClick={() => navigate('/admin')}>
              Report
            </button>
          )}

          {isAdminPage && (
            <button className={styleHeader.linkBtn} onClick={() => navigate('/search')}>
              Search
            </button>
          )}

          {isFlowPage && (
            <>
              {path === '/plan-output' ? (
                <>
                  <button
                    className={isNewPlan ? styleHeader.confirmBtn : styleHeader.inputBtn}
                    onClick={handleDownload}
                    disabled={isDownloading}
                  >
                    {/* {isNewPlan ? <CheckIcon /> : <DownloadIcon />} */}
                    {isDownloading && <div className={styleHeader.spinner}></div>}
                    <span>{isNewPlan ? 'Confirm & Download' : 'Download'}</span>
                  </button>
                  {isLatestVersion && (
                    <button className={styleHeader.pdfBtn} onClick={handleEdit}>
                      <EditIcon />
                      <span>Edit</span>
                    </button>
                  )}
                </>
              ) : (
                <>
                  <button className={styleHeader.inputBtn} onClick={handleInputScreens}>
                    <InputIcon />
                    <span>Input Screens</span>
                  </button>
                  <button className={styleHeader.pdfBtn} onClick={handlePlanPdf}>
                    <PdfIcon />
                    <span>Plan PDF</span>
                  </button>
                </>
              )}
            </>
          )}

          <div className={styleHeader.userProfile}>
            <div className={styleHeader.userIconWrapper}>
              <UserIcon />
            </div>
            <div className={styleHeader.userInfo}>
              <span className={styleHeader.userName}>{clientName}</span>
              <span className={styleHeader.userRole}>{rmName}</span>
            </div>
          </div>

          <button className={styleHeader.logoutBtn} onClick={handleLogout}>
            <LogoutIcon />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
